<template>
  <b-row>
    <Loader v-if="isLoading" size="lg"></Loader>
    <b-col class="p-0" v-else>
      <b-col cols="12" class="pl-0 pr-0">
        <div>
          <span class="h6">
            <i class="far fa-clipboard fa-lg mr-2"></i> {{ $t('menu.notes.index') }}
          </span>
          <div class="float-right">
            <button
              type='button'
              class="btn btn-info btn-circle btn-sm mt-0 mb-2 mr-0"
              v-b-tooltip.hover :title="$t('buttons.addNote')"
              @click="showAddModal()"
            >
            <i class="fa fa-plus"></i>
            </button>
          </div>
          <div v-if="items.length > 0">
          <table class="table table-hover table-sm table-striped mb-2">
            <tr>
              <th style="width: 45%"></th>
              <th style="width: 30%"></th>
              <th>ID</th>
              <th></th>
            </tr>
            <tbody>
            <tr v-for="item in items"
                :key="item['@id']">
              <td>
                <router-link v-if="item" :to="{name: 'EXCMNoteShow', params: { id: item['@id'] }}"></router-link> {{ item['title'] }}
              </td>
              <td>
                {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
              </td>
              <td>
                <router-link v-if="item && item.idCase && $route.name !== 'EXCMCaseShow'" :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
                  {{ getIdLink(item.idCase['@id']) }}
                </router-link>
                <div v-else-if="item.idCase">
                  {{ getIdLink(item.idCase['@id']) }}
                </div>
              </td>
              <td>
                <div class="btn-group float-right">
                  <button class="btn btn-link fa fa-search fa-lg" v-b-tooltip.hover :title="$t('buttons.show')" @click="showModal(item['@id'])"></button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          </div>
          <div v-else>
            {{$t('views.excmnote.list.noNotes')}}
          </div>
          <span v-if="view">
           <pagination
             :view="view"
             @getPage="getList($event)"
           ></pagination>
          </span>
        </div>
      </b-col>
    </b-col>
    <ShowModal
      :iri="noteIri"
    ></ShowModal>
    <AddNoteModal
      v-if="!hideAddModal"
      :id-case="idCase"
      :id-firm="idFirm"
      :id-organization-lead="idOrganizationLead"
    ></AddNoteModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import addParamsToQuery from '@/utils/addParamsToQuery'
import AddNoteModal from '@/components/Dashboard/Views/excmnote/modals/CreateNoteModal'
import getId from '@/utils/getIdFromLink'
import ShowModal from '@/components/Dashboard/Views/excmnote/modals/ShowNoteModal'

export default {
  name: 'TimetableNotes',

  components: {
    Loader,
    Pagination,
    ShowModal,
    AddNoteModal
  },

  props: {
    idFirm: {
      required: false
    },
    idCase: {
      required: false
    },
    idOrganizationLead: {
      required: false
    },
    hideAddModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      noteIri: null
    }
  },

  computed: {
    ...mapGetters({
      created: 'excmnote/create/created',
      deletedItem: 'excmnote/del/deleted',
      error: 'excmnote/list/error',
      items: 'excmnote/list/items',
      isLoading: 'excmnote/list/isLoading',
      view: 'excmnote/list/view'
    }),
    currentUser () {
      return this.isDashboard ? this.$store.state.picker.current : null
    },
    isDashboard () {
      return this.$route.name === 'TimetableDashboard'
    }
  },

  watch: {
    currentUser: {
      immediate: true,
      handler () {
        if (this.isDashboard && this.currentUser) {
          this.fetchNotes()
        } else if (!this.isDashboard) {
          this.fetchNotes()
        }
      }
    },
    created (val) {
      if (val) {
        this.fetchNotes()
        this.$emit('noteAdded')
      }
    }
  },

  methods: {
    fetchNotes () {
      let url = addParamsToQuery('e_x_c_m_notes', {
        createdBy: getId(this.currentUser),
        state: 1,
        idUserData: getId(this.idFirm),
        idCase: getId(this.idCase),
        idOrganizationLead: getId(this.idOrganizationLead)
      })
      this.getList(url)
    },
    getIdLink (link) {
      return getId(link)
    },
    showAddModal () {
      this.toggleAddModal()
    },
    showModal (id) {
      this.noteIri = id
      this.toggleShowModal()
    },
    ...mapActions({
      getList: 'excmnote/list/default'
    }),
    ...mapMutations({
      toggleAddModal: 'excmnote/createModal/toggleModal',
      toggleShowModal: 'excmnote/showModal/toggleModal'
    })
  }
}
</script>
